module.exports = __webpack_public_path__ + "static/media/mitsubishi-minus.f8453ea6.svg";